<div class="modal-content">
    <div
        class="modal-header"
        style="
            background-color: #569c5b;
            color: #fff;
            cursor: all-scroll;
            padding: 0.2rem 1rem;
        "
    >
        <h4 class="modal-title pl-3">
            Détails <strong>[{{ transaction?.reference }}]</strong>
        </h4>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="handleCloseModal()"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <!--------------------MODAL----------SIDEBAR---------->
            <div class="col-lg-2">
                <ul class="list-group pl-3">
                    <li
                        style="cursor: pointer; font-size: 15px"
                        [ngClass]="
                            filterTab === 'first-item'
                                ? 'active'
                                : 'bg_light_green'
                        "
                        (click)="filterItem('first-item')"
                        class="list-group-item cursor-pointer"
                    >
                        Information Message
                    </li>
                </ul>
                <div>
                    <fieldset>
                        <legend>
                            <strong>ExpediteurDSVDF</strong>
                        </legend>
                        <div class="d-flex flex-column gap-2">
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Matricule&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.expediteur
                                            ?.matricule ?? 'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Nom complet&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.expediteur?.nom ??
                                            'N/A'
                                    }}
                                    {{
                                        detailTransaction?.expediteur
                                            ?.prenoms ?? 'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Contact&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.expediteur
                                            ?.contacts ?? 'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Email&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.expediteur?.email ??
                                            'N/A'
                                    }}</span
                                >
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div>
                    <fieldset>
                        <legend>
                            <strong>Lecteur</strong>
                        </legend>
                        <div class="d-flex flex-column gap-2">
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Matricule&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.lecteur?.matricule ??
                                            'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Nom complet&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.lecteur?.nom ?? 'N/A'
                                    }}
                                    {{
                                        detailTransaction?.lecteur?.prenoms ??
                                            'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Contact&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.lecteur?.contacts ??
                                            'N/A'
                                    }}</span
                                >
                            </div>
                            <div>
                                <span class="mb-0 fs__30"
                                    ><strong>Email&nbsp;:&nbsp;</strong
                                    >{{
                                        detailTransaction?.lecteur?.email ??
                                            'N/A'
                                    }}</span
                                >
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
            <!--------------------MODAL----------BODY---------->
            <div class="col-lg-10">
                <div
                    [ngClass]="[
                        detailTransaction?.statut === 'lu'
                            ? 'styleForLu'
                            : 'styleForNonLu'
                    ]"
                    role="alert"
                    style="display: flex; justify-content: space-between"
                >
                    <div>
                        <strong class="wrapper-header">
                            Date d'envoi :
                            {{ [detailTransaction?.created_at] ?? '-- : --' }}
                        </strong>
                    </div>
                    <div>
                        <strong class="wrapper-header">
                            Date de lecture :
                            {{ [detailTransaction?.lu_a] ?? '-- : --' }}
                        </strong>
                    </div>
                </div>
                <div
                    [hidden]="filterTab !== 'first-item'"
                    [formGroup]="adminForm"
                >
                    <fieldset>
                        <legend>
                            <b>Sujets</b>
                        </legend>
                        <div>
                            <div style="display: flex; gap: 2rem">
                                <div
                                    class="trans-radio d-flex gap-3"
                                    *ngIf="getSujet === sourceOffreCommercial"
                                >
                                    <p-radioButton
                                        name="sujet"
                                        formControlName="sujet"
                                        [value]="sourceOffreCommercial"
                                        [inputId]="sourceOffreCommercial"
                                    ></p-radioButton>
                                    <label
                                        [for]="sourceOffreCommercial"
                                        style="margin-top: 0.9rem"
                                        >Offre Commerciale</label
                                    >
                                </div>
                                <div
                                    class="trans-radio d-flex gap-3"
                                    *ngIf="getSujet === sourceContrat"
                                >
                                    <p-radioButton
                                        name="sujet"
                                        formControlName="sujet"
                                        [value]="sourceContrat"
                                        [inputId]="sourceContrat"
                                    ></p-radioButton>
                                    <label
                                        [for]="sourceContrat"
                                        style="margin-top: 0.9rem"
                                        >Contrat</label
                                    >
                                </div>
                                <div
                                    class="trans-radio d-flex gap-3"
                                    *ngIf="getSujet === sourceFacture"
                                >
                                    <p-radioButton
                                        name="sujet"
                                        formControlName="sujet"
                                        [value]="sourceFacture"
                                        [inputId]="sourceFacture"
                                    ></p-radioButton>
                                    <label
                                        [for]="sourceFacture"
                                        style="margin-top: 0.9rem"
                                        >Facture</label
                                    >
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>
                            <b>Contenu</b>
                        </legend>
                        <div class="row" style="padding-top: 0rem !important">
                            <div class="form-group">
                                <label>
                                    <b
                                        >Objet<span class="text-danger"
                                            >*</span
                                        ></b
                                    >
                                </label>
                                <input
                                    type="text"
                                    formControlName="objet"
                                    pInputText
                                />
                            </div>
                        </div>
                        <div class="row" style="padding-top: 0.8rem !important">
                            <div class="form-group">
                                <label>
                                    <b
                                        >Message<span class="text-danger"
                                            >*</span
                                        ></b
                                    >
                                </label>
                                <textarea
                                    rows="2"
                                    formControlName="message"
                                    cols="30"
                                    pInputTextarea
                                ></textarea>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>
                            <b>Signature</b>
                        </legend>
                        <div class="row" style="padding-top: 0 !important">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>
                                        <b
                                            >Nom<span class="text-danger"
                                                >*</span
                                            ></b
                                        >
                                    </label>
                                    <input
                                        type="text"
                                        formControlName="signature_nom"
                                        pInputText
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>
                                        <b
                                            >Fonction<span class="text-danger"
                                                >*</span
                                            ></b
                                        >
                                    </label>
                                    <input
                                        type="text"
                                        formControlName="signature_fonction"
                                        pInputText
                                    />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>
                                        <b
                                            >Contact<span class="text-danger"
                                                >*</span
                                            ></b
                                        >
                                    </label>
                                    <input
                                        type="text"
                                        formControlName="signature_contact"
                                        pInputText
                                    />
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
        <div class="justificatif-container mt-4">
            <div *ngIf="IsJustificatif()">
                <button
                    pButton
                    pRipple
                    label="Télécharger la pièce"
                    icon="pi pi-download"
                    class="p-button-success"
                    (click)="downloadFile()"
                ></button>
            </div>
            <div class="justificatif-error">
                <span class="" *ngIf="!IsJustificatif()"
                    >Aucune pièce pour ce message</span
                >
            </div>
        </div>
    </div>
</div>
